import { cn } from 'src/lib/utils';

import { EmptyIcon } from '../icons';

export function Empty({ text = '暂无数据', className }: { text?: string; className?: string }) {
  return (
    <div className={cn('size-full relative', className)}>
      <div className="absolute inset-0 flex flex-col justify-center items-center gap-2">
        <EmptyIcon />
        <span className="text-muted-foreground text-sm">{text}</span>
      </div>
    </div>
  );
}
